// Aminities.jsx — context-ல் இருந்து aminities + aminitiesCategories எடுக்கிறோம்
import React, { useState, useContext } from "react";
import { MyContext } from "../../../../Context/MyContext";
import "./FormComponents.css";
import AppIcon from "../../../../Components/AppIcon";

const AminitiesBlock = ({ value = [], onChange }) => {
  const { aminities, aminitiesCategories } = useContext(MyContext);
  const [activeCat,   setActiveCat]   = useState(null);
  const [customInput, setCustomInput] = useState("");
  const [showCustom,  setShowCustom]  = useState(false);

  const allAminities = Array.isArray(aminities) ? aminities : [];
  const allCats      = Array.isArray(aminitiesCategories) ? aminitiesCategories : [];

  // ✅ Preset IDs (number) + custom strings separated
  const presetIds   = value.filter(v => typeof v === "number" || (!isNaN(Number(v)) && typeof v !== 'string'));
  const customItems = value.filter(v => typeof v === "string" && v.trim() !== "" && isNaN(Number(v)));

  const togglePreset = (id) => {
    const numId = Number(id);
    const updated = presetIds.map(Number).includes(numId)
      ? value.filter(v => Number(v) !== numId)
      : [...value, numId];
    onChange("aminities", updated);
  };

  const addCustom = () => {
    const trimmed = customInput.trim();
    if (!trimmed || customItems.includes(trimmed)) { setCustomInput(""); return; }
    onChange("aminities", [...value, trimmed]);
    setCustomInput("");
  };

  const removeCustom = (item) => onChange("aminities", value.filter(v => v !== item));

  const filtered = activeCat
    ? allAminities.filter(a => a.category_id === activeCat)
    : allAminities;

  return (
    <div className="aminities-block">
      <div className="aminities-category-tabs">
        <button className={`cat-tab${activeCat === null ? " active" : ""}`} type="button" onClick={() => setActiveCat(null)}>All</button>
        {allCats.map(c => (
          <button key={c.id} type="button" className={`cat-tab${activeCat === c.id ? " active" : ""}`} onClick={() => setActiveCat(c.id)}>
            {c.name}
          </button>
        ))}
      </div>

      <div className="aminities-grid">
        {filtered.map(item => {
          const checked = presetIds.map(Number).includes(Number(item.id));
          return (
            <label key={item.id} className={`aminitie-item${checked ? " checked" : ""}`}>
              <input type="checkbox" checked={checked} onChange={() => togglePreset(item.id)}/>
              <span className="check-box-custom">
                {checked && <svg viewBox="0 0 12 10" fill="none" stroke="currentColor" strokeWidth="2.2" width="10" height="10"><polyline points="1 5 4.5 8.5 11 1"/></svg>}
              </span>
              <span className="aminitie-name">{item.aminitie_name}</span>
            </label>
          );
        })}
      </div>

      {customItems.length > 0 && (
        <div className="custom-aminities-wrap">
          <p className="custom-am-label">Custom Amenities</p>
          <div className="custom-am-chips">
            {customItems.map((item, i) => (
              <span key={i} className="custom-am-chip">
                {item}
                <button type="button" className="custom-am-remove" onClick={() => removeCustom(item)}>×</button>
              </span>
            ))}
          </div>
        </div>
      )}

      {showCustom ? (
        <div className="custom-am-input-row">
          <input className="custom-am-input" type="text" placeholder="e.g. Rooftop Pool..."
            value={customInput} onChange={e => setCustomInput(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }} autoFocus/>
          <button type="button" className="custom-am-add-btn" onClick={addCustom}>Add</button>
          <button type="button" className="custom-am-cancel-btn" onClick={() => { setShowCustom(false); setCustomInput(""); }}>Cancel</button>
        </div>
      ) : (
        <button type="button" className="add-more-btn am-add-custom-btn" onClick={() => setShowCustom(true)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="13" height="13">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>Add Custom Amenity
        </button>
      )}

      {value.length > 0 && (
        <div className="aminities-selected-count">
          <AppIcon name="sparkle" size={14} /> {value.length} {value.length === 1 ? "amenity" : "amenities"} selected
          {customItems.length > 0 && ` (${customItems.length} custom)`}
        </div>
      )}
    </div>
  );
};

export default AminitiesBlock;